// extracted by mini-css-extract-plugin
export default {"wide":"section-grid_wide__7+F3c","grid":"section-grid_grid__ZNDK6","poster":"section-grid_poster__k0q9d","streaming-service":"section-grid_streaming-service__lLYWl"};